import React from 'react';
import EmbedViewer from './EmbedViewer';
import { SceneConfig } from '../types/sceneConfig';
import type { POIData } from './POIOverlay';

interface GpsPosition {
  latitude: number;
  longitude: number;
  altitude: number;
  heading: number;
}

interface RealEstateViewerProps {
  scene: SceneConfig;
  pois?: POIData[];
  onBack?: (gpsPosition: GpsPosition | null) => void;
  isPopupMode?: boolean;
}

/**
 * Standalone real-estate viewer boundary. It currently preserves the existing
 * experience while allowing this route to evolve independently of embeds.
 */
const RealEstateViewer: React.FC<RealEstateViewerProps> = (props) => (
  <div className="fixed inset-0 bg-[#091117]">
    <EmbedViewer {...props} embeddedMode={false} showChat={false} showNavigationHint={false} showViewerToolbar={false} initialExposure={1.35} showSunPathTool showInsightCards />
  </div>
);

export default RealEstateViewer;
